import { AppRootEnum } from "./app-root-enum";

let bundlesToLoad = 0;
let resolve = null;

const importPath = async (folder: string, name: string, appRoot: AppRootEnum) => {
    switch (appRoot) {
        case AppRootEnum.sharedComponents:
            folder = folder.replace(`${appRoot}/`, "");

            return import(
                /* webpackInclude: /_/ */
                `../../../../libs/shared-components/${folder}/_${name}`
            );

        case AppRootEnum.standalone:
            folder = folder.replace(`${appRoot}/`, "");

            return import(
                /* webpackInclude: /_/ */
                `../standalone-pages/${folder}/_${name}`
            );

        case AppRootEnum.app:
            return import(
                /* webpackInclude: /_/ */
                `../${folder}/_${name}`
            );

        default:
            return import(
                /* webpackInclude: /_/ */
                `../app/${folder}/_${name}`
            );
    }
};

export const useBundleLoader = () => {
    window.bundle = (folder: string, name: string) => {
        bundlesToLoad++;

        const appRoot = folder.substring(0, folder.indexOf("/")) as AppRootEnum;

        return importPath(folder, name, appRoot).finally(() => {
            bundlesToLoad--;
            if (bundlesToLoad == 0) {
                // jquery dom ready is here because bundles may also have have dom ready,
                // which is queue, so this needs to be queued last
                $(() => {
                    resolve();
                });
            }
        });
    };

    window.noBundles = () => {
        resolve();
    };

    return new Promise<void>((res) => {
        resolve = res;
    });
};
